import React, { useState, useEffect } from 'react'
import Header from '../Components/Header'
import StudentSdebar from './StudentSdebar'
// import Footer from "../Components/Footer";
import axios from 'axios'
import Swal from 'sweetalert2'

const AddCourses = () => {
  const [courseData, setCourseData] = useState({
    title: '',
    start_date: '',
    reference_num: '',
    price: '',
    description: '',
    trailer: '',
    categories: [],
  })

  const [categoryInput, setCategoryInput] = useState('')
  const [isInstructor, setIsInstructor] = useState(false)

  useEffect(() => {
    const role = localStorage.getItem('role')
    setIsInstructor(role === 'Instructor')
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setCourseData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleTrailerFile = (e) => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setCourseData((prevData) => ({
          ...prevData,
          trailer: reader.result,
        }))
      }
      reader.readAsDataURL(file)
    }
  }

  const handleCategoryAdd = () => {
    if (categoryInput.trim()) {
      setCourseData((prevData) => ({
        ...prevData,
        categories: [...prevData.categories, categoryInput.trim()],
      }))
      setCategoryInput('')
    }
  }

  const handleCategoryRemove = (index) => {
    setCourseData((prevData) => ({
      ...prevData,
      categories: prevData.categories.filter((_, i) => i !== index),
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const token = localStorage.getItem('jwttoken')
    try {
      await axios.put('https://kaasbackend.vetrinahealthcare.com/lms/courses/', courseData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
      Swal.fire({
        title: 'Success!',
        text: 'Course added successfully!',
        icon: 'success',
        confirmButtonText: 'OK',
      })
      setCourseData({
        title: '',
        start_date: '',
        reference_num: '',
        price: '',
        description: '',
        trailer: '',
        categories: [],
      })
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to add course. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      })
    }
  }

  return (
    <>
      <Header />
      <div
        style={{
          backgroundImage:
            'linear-gradient(180.06deg, #E9F7FA 29.88%, #F8EEF5 58.49%)',
        }}
      >
        <div className='d-flex flex-row'>
          <StudentSdebar />
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-md-8 py-4'>
                <div
                  className='text-center border rounded mx-auto text-light mb-4 p-1'
                  style={{
                    background:
                      'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
                    width: '80%',
                    maxWidth: '300px',
                  }}
                >
                  <h1 style={{ fontSize: '24px' }}>Add a New Course</h1>
                </div>
                {isInstructor ? (
                  <form onSubmit={handleSubmit}>
                    {/* Course Title */}
                    <div className='mb-3'>
                      <label htmlFor='title' className='form-label'>
                        Course Title
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        id='title'
                        name='title'
                        style={{ borderRadius: '10px' }}
                        value={courseData.title}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Start Date */}
                    <div className='mb-3'>
                      <label htmlFor='start_date' className='form-label'>
                        Start Date
                      </label>
                      <input
                        type='date'
                        className='form-control'
                        id='start_date'
                        name='start_date'
                        style={{ borderRadius: '10px' }}
                        value={courseData.start_date}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Reference Number */}
                    <div className='mb-3'>
                      <label htmlFor='reference_num' className='form-label'>
                        Reference Number
                      </label>
                      <input
                        type='number'
                        className='form-control'
                        id='reference_num'
                        name='reference_num'
                        style={{ borderRadius: '10px' }}
                        value={courseData.reference_num}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Price */}
                    <div className='mb-3'>
                      <label htmlFor='price' className='form-label'>
                        Price
                      </label>
                      <input
                        type='number'
                        step='0.01'
                        className='form-control'
                        id='price'
                        name='price'
                        style={{ borderRadius: '10px' }}
                        value={courseData.price}
                        onChange={handleChange}
                        min={0}
                        required
                      />
                    </div>

                    {/* Description */}
                    <div className='mb-3'>
                      <label htmlFor='description' className='form-label'>
                        Description
                      </label>
                      <textarea
                        className='form-control'
                        id='description'
                        name='description'
                        style={{ borderRadius: '10px' }}
                        value={courseData.description}
                        onChange={handleChange}
                        rows='3'
                        required
                      ></textarea>
                    </div>

                    {/* Trailer Upload */}
                    <div className='mb-3'>
                      <label htmlFor='trailerFile' className='form-label'>
                        Upload Trailer (Video File)
                      </label>
                      <input
                        type='file'
                        className='form-control'
                        id='trailerFile'
                        style={{ borderRadius: '10px' }}
                        onChange={handleTrailerFile}
                        accept='video/*'
                      />
                      {courseData.trailer && (
                        <div className='mt-3'>
                          <label className='form-label'>Trailer Preview:</label>
                          <video width='100%' controls>
                            <source src={courseData.trailer} type='video/mp4' />
                          </video>
                        </div>
                      )}
                    </div>

                    {/* Categories */}
                    <div className='mb-3'>
                      <label className='form-label'>Categories</label>
                      <div
                        className='input-group mb-3'
                        style={{ borderRadius: '10px' }}
                      >
                        <input
                          type='text'
                          className='form-control'
                          value={categoryInput}
                          onChange={(e) => setCategoryInput(e.target.value)}
                          placeholder='Add a category'
                        />
                        <button
                          type='button'
                          className='btn btn-primary'
                          style={{
                            background:
                              'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
                            border: 'none',
                          }}
                          onClick={handleCategoryAdd}
                        >
                          Add
                        </button>
                      </div>
                      <ul className='list-group'>
                        {courseData.categories.map((category, index) => (
                          <li
                            key={index}
                            className='list-group-item d-flex justify-content-between align-items-center'
                          >
                            {category}
                            <button
                              type='button'
                              className='btn btn-danger btn-sm'
                              onClick={() => handleCategoryRemove(index)}
                            >
                              Remove
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Submit Button */}
                    <button
                      type='submit'
                      className='btn btn-success'
                      style={{
                        background:
                          'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
                        border: 'none',
                      }}
                    >
                      Add Course
                    </button>
                  </form>
                ) : (
                  <div className='alert alert-danger' role='alert'>
                    You do not have permission to add courses. Only instructors
                    can access this feature.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </>
  )
}

export default AddCourses
